export default __webpack_public_path__ + "static/movie-da604f98794f2468965bdb5dea51a221.mp4";